import React from 'react';
import { Box, Checkbox, Typography, Chip, Tooltip, IconButton, Stack, Badge } from '@mui/material';
const theme = createTheme();
import { createTheme } from '@mui/material/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FULL_PERMISSION } from '../../../constants/Constant';
import ProfileInitial from '../../profile/profileInitial';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';

const ParticipantRow = (props) => {
    const {item, index, classes} = props;
    let actData = item.actualData;

    return (
        <Box className={classes.cardRowContent}>
            {/* {data[index].actualData.name} */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.05', justifyContent: 'center' }}>
                <Checkbox
                    inputProps={{
                        'aria-label': 'Participant',
                    }}
                    checked={item.selected ? item.selected : false}
                    onChange={(event) => props.onCheckSelect(event, index)}
                    // color="secondary"
                    value={actData.eventUsersID}
                    sx={{ marginLeft: theme.spacing(-1) }}
                // disabled={
                //     item.disableRow != undefined ? item.disableRow : false
                // }
                />
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.15', justifyContent: 'left' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={400}>
                        <span>{actData.name}</span>
                        <Typography
                            fontSize={11}
                            sx={{
                                wordBreak: 'break-word',
                            }}>
                            <a
                                href={`mailto:${actData.email}`}>
                                {' '}
                                {actData.email}{' '}
                            </a>
                        </Typography>
                        {actData.userType && actData.userType == "Admin" ? <Typography
                            fontSize={11} 
                            sx={{color:'red'}}
                        >
                            Admin
                        </Typography> : null}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.05', justifyContent: 'left' }}>
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={14}
                    fontWeight={400}>
                    <span>{actData.roleName}</span>
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.25', justifyContent: 'center', margin: theme.spacing(0, 1) }}>
                <Box sx={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        color="primary">
                        Can Act on Behalf of
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                        }}>
                        <Stack
                            direction="row"
                            spacing={-1.8}
                            flexWrap="wrap">
                            {actData.userConnection.map((rowItem, rowIndex) => {
                                return (
                                    <IconButton
                                        key={`profile_${rowIndex}`}
                                        size="small"
                                        aria-label="account of current user"
                                        aria-controls="primary-search-account-menu"
                                        aria-haspopup="true"
                                        color="inherit"
                                        onClick={() =>
                                            props.deleteConnection(rowItem)
                                        }>
                                        <Badge
                                            overlap="circular"
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            badgeContent={
                                                <RemoveCircleIcon
                                                    fontSize="small"
                                                    sx={{ color: 'red' }}
                                                    className={
                                                        classes.setScale
                                                    }></RemoveCircleIcon>
                                            }>
                                            <ProfileInitial
                                                data={rowItem}
                                                showOnlyInitial={true}
                                                navigationScreen={
                                                    'changeUser'
                                                }
                                            />
                                            {/* <GroupAvatar
                                                        data={rowItem}
                                                    /> */}
                                        </Badge>
                                    </IconButton>
                                );
                            })}
                        </Stack>
                        <IconButton
                            color="primary"
                            onClick={() => props.addConnection(item)}
                        >
                            <AddCircleRoundedIcon
                                fontSize="small"
                                color={'primary'}
                            />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.25', justifyContent: 'center', margin: theme.spacing(0, 1) }}>
                <Box sx={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        color="primary">
                        Linked With
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                        }}>
                        <Stack
                            direction="row"
                            spacing={-1.8}
                            flexWrap="wrap">
                            {actData.linkedWith.map((rowItem, rowIndex) => {
                                return (
                                    <IconButton
                                        key={`profile_${rowIndex}`}
                                        size="small"
                                        aria-label="account of current user"
                                        aria-controls="primary-search-account-menu"
                                        aria-haspopup="true"
                                        color="inherit"
                                        onClick={() =>
                                            props.deleteConnection(rowItem)
                                        }>
                                        <Badge
                                            overlap="circular"
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            badgeContent={
                                                <RemoveCircleIcon
                                                    fontSize="small"
                                                    sx={{ color: 'red' }}
                                                    className={
                                                        classes.setScale
                                                    }></RemoveCircleIcon>
                                            }>
                                            <ProfileInitial
                                                data={rowItem}
                                                showOnlyInitial={true}
                                                navigationScreen={
                                                    'changeUser'
                                                }
                                            />
                                            {/* <GroupAvatar
                                                        data={rowItem}
                                                    /> */}
                                        </Badge>
                                    </IconButton>
                                );
                            })}
                        </Stack>
                        <IconButton
                            color="primary"
                            onClick={() =>
                                props.addConnectionLinkedWith(item)
                            }>
                            <AddCircleRoundedIcon
                                fontSize="small"
                                color={'primary'}
                            />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.1', justifyContent: 'left' }}>
                <>
                    {actData.userTags ?
                        actData.userTags.split(', ').map((chipItem) => {
                            return (
                                <Chip
                                    key={chipItem}
                                    label={chipItem}
                                    sx={{ mr: '4px', mb: '2px' }}
                                />
                            );
                        })
                        : null}
                </>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.1', justifyContent: 'left', flexDirection: 'column' }}>
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={12}
                    fontWeight={500}
                    color="primary">
                    Status
                </Typography>
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={14}
                    fontWeight={400}>
                    <span>{actData.status ? 'Active' : 'Inactive'}</span>
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.05', justifyContent: 'flex-end', }}>
                {props.modPermission &&
                    props.modPermission == FULL_PERMISSION ? (
                    <Tooltip title="Edit" aria-label="edit">
                        <IconButton
                            color="primary"
                            onClick={() => props.editRow(item)}>
                            <EditOutlinedIcon
                                fontSize="small"
                                color={'primary'}
                            />
                        </IconButton>
                    </Tooltip>
                ) : null}
            </Box>
        </Box>
    )
}

export default ParticipantRow;